import { computed, toValue } from 'vue'
import { defineStore } from 'pinia'
import Query from '@/classes/queries/Query'
import Client from '@/classes/clients/Client'
import Statistics from '@/classes/statistics/Statistics'
import store from '@/store'

export const useClientStore = defineStore('ClientStore', {
  state: () => ({
    client: {},
    statistics: {},
    loader: false,
    error: {}
  }),
  getters: {
    getClientFromState: state => state.$getItemFromState('client'),
    getClient: state => () => state.$getItem({
      resource: 'client',
      fetch: () => state.fetchClient()
    }),
    getStatistics: state => ({ query, reload = false, dependencies, multi_currency = true } = {}) => {
      const key = computed(() => new Query({ query: toValue(query), default_value: 'default' }).to_string)

      return state.$getItem({
        resource: 'statistics',
        key,
        query,
        reload,
        dependencies,
        multi_currency,
        fetch: () => state.fetchClientStatistics({ query, multi_currency })
      })
    }
  },
  actions: {
    fetchClient () {
      return this.$fetchItem({
        endpoint: '/api/v1/client',
        resource: 'client',
        model: Client
      }).then(client => {
        store.commit('client/setClient', client)
        return client
      })
    },
    fetchClientStatistics ({ query, multi_currency = true }) {
      const key = computed(() => new Query({ query: toValue(query), default_value: 'default' }).to_string)

      return this.$fetchItem({
        endpoint: '/api/v1/client/statistics',
        resource: `statistics.['${key.value}']`,
        model: Statistics,
        query,
        multi_currency
      })
    }
  }
})